import { lazy } from "react"

export const DriverById = lazy(() => import("./DriverById"))
